/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface OauthLogin200Response
 */
export interface OauthLogin200Response {
  /**
   *
   * @type {string}
   * @memberof OauthLogin200Response
   */
  token_type: string
  /**
   * Срок жизни access-токена в секундах
   * @type {number}
   * @memberof OauthLogin200Response
   */
  expires_in: number
  /**
   *
   * @type {string}
   * @memberof OauthLogin200Response
   */
  access_token: string
  /**
   *
   * @type {string}
   * @memberof OauthLogin200Response
   */
  refresh_token: string
}

/**
 * Check if a given object implements the OauthLogin200Response interface.
 */
export function instanceOfOauthLogin200Response(
  value: object
): value is OauthLogin200Response {
  if (!('token_type' in value) || value['token_type'] === undefined)
    return false
  if (!('expires_in' in value) || value['expires_in'] === undefined)
    return false
  if (!('access_token' in value) || value['access_token'] === undefined)
    return false
  if (!('refresh_token' in value) || value['refresh_token'] === undefined)
    return false
  return true
}

export function OauthLogin200ResponseFromJSON(
  json: any
): OauthLogin200Response {
  return OauthLogin200ResponseFromJSONTyped(json, false)
}

export function OauthLogin200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OauthLogin200Response {
  if (json == null) {
    return json
  }
  return {
    token_type: json['token_type'],
    expires_in: json['expires_in'],
    access_token: json['access_token'],
    refresh_token: json['refresh_token'],
  }
}

export function OauthLogin200ResponseToJSON(
  value?: OauthLogin200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    token_type: value['token_type'],
    expires_in: value['expires_in'],
    access_token: value['access_token'],
    refresh_token: value['refresh_token'],
  }
}
